import React from "react";

const Text = (props) => {
    return(
        <p>
            {props.text.content}
        </p>
    )
}

export default Text;